// Meta Pixel tracking helpers — deduplication + cookie capture

const PIXEL_ID = process.env.REACT_APP_META_PIXEL_ID;

/** Read _fbp cookie set by Meta Pixel */
export function getMetaFbp() {
  const match = document.cookie.match(/(?:^|; )_fbp=([^;]*)/);
  return match ? decodeURIComponent(match[1]) : "";
}

/** Read _fbc cookie (click-id from Meta ads) */
export function getMetaFbc() {
  const match = document.cookie.match(/(?:^|; )_fbc=([^;]*)/);
  return match ? decodeURIComponent(match[1]) : "";
}

// Session-level dedup set — prevents duplicate browser events
const firedEvents = new Set();

/**
 * Fire a Meta Pixel browser event with deduplication.
 * @param {string} eventName  - e.g. "CompleteRegistration", "Purchase"
 * @param {string} eventId    - Unique ID shared with CAPI for dedup
 * @param {object} customData - Optional event parameters
 */
export function trackMetaEvent(eventName, eventId, customData = {}) {
  if (!PIXEL_ID || typeof window.fbq !== "function") return;
  if (!eventId) return;
  if (firedEvents.has(eventId)) return;

  firedEvents.add(eventId);
  window.fbq("track", eventName, customData, { eventID: eventId });
}
